import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SetTuitionAgreement = graphql.persisted(
  "SetTuitionAgreement",
  graphql(`mutation SetTuitionAgreement($input: SetTuitionAgreementInput!) {
    setTuitionAgreement(input: $input) {
      item {
        id title round state completedAt
        tuitionAgreement {
          agreementId state paymentOptionKey aidRequested aidCents aidReason totalCents
          installments { dueOn amountCents autoPay }
          kept { dueOn amountCents status }
          supersedesAgreementId
          offeredAt signedAt signedName signedMethod
        }
      }
      errors
    }
  }`)
);

export { SetTuitionAgreement };
export function useSetTuitionAgreement() {
  return useMutation(SetTuitionAgreement);
}
